<template>
  <!-- <textarea style="width:100%">{{ JSON.stringify(currentMenu,null,2) }}</textarea> -->
  <div style="height:100%">
    <menuNav :CurrentMenu="menuItem" :key="itemIndex" v-if="itemIndex == currentIndex" v-for="(menuItem, itemIndex) in allMenu"></menuNav>
  </div>
</template>
<script>
import menuNav from "./menuNav";

export default {
  components: { menuNav },
  data() {
    return {
      msg: "fwegwenhubgiwoelghijwe",
    };
  },
  computed: {
    currentIndex() {
      return this.$route.params.index;
    },
    allMenu() {
      let { currentIndex } = this;
      let _arr = this.$app.menus.filter((p) => p.children && p.children.length > 0);
      return _arr;
    },
    // 跟据路由自动切换倒当前菜单
    // currentMenu() {
    //   let { currentIndex } = this;
    //   let _arr = this.$app.menus.filter((p) => p.children && p.children.length > 0);
    //   return _arr[currentIndex];
    // },
    // 跟据路由自动切换到当前菜单缓存
    // currentMenuStore() {
    //   const { currentIndex, $store } = this;
    //   return $store.state.core.menuStore.modules[currentIndex] || {};
    // },
  },
};
</script>
